import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpansionPanel,[_c(VExpansionPanelHeader,[_vm._t("header",function(){return [_c('div',{staticClass:"accordion-toggle question-toggle"},[_vm._v(_vm._s(_vm.question))])]},{"question":_vm.question})],2),_c(VExpansionPanelContent,[_vm._t("answer",function(){return [_c('div',{staticClass:"answer",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.answer))}})]},{"answer":_vm.answer})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }